<template>
	<div class="d-flex flex-1 flex-column">
		<!-- Integration Entities Section -->
		<v-card class="report-container w-100 p-0" style="border-radius: 12px; margin-bottom: 24px">
			<v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Label_ManageMOISettings") }}</v-toolbar-title>
            </v-toolbar>
            <div style="padding: 16px 24px; display: flex; align-items: center; justify-content: space-between;">
            	<h3 class="text-lg font-weight-600">Integration Entities</h3>
				<v-btn @click="addRow" width="200px" color="primary">{{ $t("res_ButtonText_Add") }}</v-btn>
            </div>
			<div class="d-flex flex-1 flex-column" style="overflow: visible; padding: 5px; padding-top: 16px;">
				<v-data-table :headers="integrationHeaders" :items="integrationEntities" :items-per-page="-1" disable-sort hide-default-footer class="elevation-1">
					<template v-slot:item="row">
						<tr>
							<td class="pa-2" style="max-width: 200px;">
								<structure-user-selector
									:showInternalStructures="false"
									:showExternalStructures="true"
									:isMultiple="false"
									:selectedStructureUser="row.item.structure"
									@structureUserSelectChanged="(structure) => row.item.structure = structure"
								></structure-user-selector>
							</td>
							<td class="pa-2">
								<v-text-field v-model="row.item.url" solo dense placeholder="Enter URL"></v-text-field>
							</td>
							<td class="pa-2">
								<v-text-field v-model="row.item.username" solo dense placeholder="Enter username"></v-text-field>
							</td>
							<td class="pa-2">
								<v-text-field v-model="row.item.password" type="password" solo dense placeholder="Enter password"></v-text-field>
              </td>
              <td class="pa-2 text-center">
                <v-switch
                  v-model="row.item.active"
                  inset
                  hide-details
                  small
                  color="primary"
                ></v-switch>
              </td>
              <td class="text-start pa-2">
							<div class="onhover-display" style="display: flex; gap: 8px;">
								<div class="custom-icon-wrapper">
									<v-tooltip bottom class="custom-tooltip">
										<template v-slot:activator="{ on, attrs }">
											<v-icon small @click="saveRow(row.item)" style="cursor: pointer; color: #4caf50;" v-bind="attrs" v-on="on">mdi-content-save</v-icon>
										</template>
										<span class="tooltip-text">Save</span>
									</v-tooltip>
								</div>
								<div class="custom-icon-wrapper">
									<v-tooltip bottom class="custom-tooltip">
										<template v-slot:activator="{ on, attrs }">
											<v-icon small @click="removeRow(row.index)" style="cursor: pointer; color: #f44336;" v-bind="attrs" v-on="on">mdi-delete</v-icon>
										</template>
										<span class="tooltip-text">Delete</span>
									</v-tooltip>
								</div>
							</div>
						</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</v-card>

		<!-- Global Mappings Section -->
		<v-card class="report-container w-100 p-0" style="border-radius: 12px; margin-bottom: 24px">
			<div style="padding: 16px 24px; display: flex; align-items: center; justify-content: space-between;">
            	<h3 class="text-lg font-weight-600">Global Mappings</h3>
				<v-btn @click="addGlobalMapping" width="200px" color="primary">{{ $t("res_ButtonText_Add") }}</v-btn>
            </div>
			<div class="d-flex flex-1 flex-column" style="overflow: visible; padding: 5px; padding-top: 16px;">
				<v-data-table :headers="globalMappingHeaders" :items="globalMappings" :items-per-page="-1" disable-sort hide-default-footer class="elevation-1">
					<template v-slot:item="row">
						<tr>
							<td class="pa-2" style="max-width: 200px;">
								<structure-user-selector
									:showInternalStructures="true"
									:showExternalStructures="true"
									:isMultiple="false"
									:selectedStructureUser="row.item.structure"
									@structureUserSelectChanged="(structure) => row.item.structure = structure"
								></structure-user-selector>
							</td>
							<td class="pa-2">
								<v-text-field v-model="row.item.globalMappingId" solo dense placeholder="Enter Global Mapping ID"></v-text-field>
							</td>
							<td class="text-start pa-2">
								<div class="onhover-display" style="display: flex; gap: 8px;">
									<div class="custom-icon-wrapper">
										<v-tooltip bottom class="custom-tooltip">
											<template v-slot:activator="{ on, attrs }">
												<v-icon small @click="saveGlobalMapping(row.item)" style="cursor: pointer; color: #4caf50;" v-bind="attrs" v-on="on">mdi-content-save</v-icon>
											</template>
											<span class="tooltip-text">Save</span>
										</v-tooltip>
									</div>
									<div class="custom-icon-wrapper">
										<v-tooltip bottom class="custom-tooltip">
											<template v-slot:activator="{ on, attrs }">
												<v-icon small @click="removeGlobalMapping(row.index)" style="cursor: pointer; color: #f44336;" v-bind="attrs" v-on="on">mdi-delete</v-icon>
											</template>
											<span class="tooltip-text">Delete</span>
										</v-tooltip>
									</div>
								</div>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</v-card>
	</div>
</template>


<script>
import axios from 'axios'
import router from '@/router/index.js'
import constants from "@/assets/js/constants.js";
import StructureUserSelector from '@/components/StructureUserSelector.vue'

export default {
  components: {
    StructureUserSelector
  },
  data() {
    return {
      integrationHeaders: [
        { text: 'Structure', value: 'structure', align: 'start', width: '24%' },
        { text: 'URL', value: 'url', align: 'start', width: '22%' },
        { text: 'Username', value: 'username', align: 'start', width: '18%' },
        { text: 'Password', value: 'password', align: 'start', width: '18%' },
        { text: 'Active', value: 'active', align: 'center', width: '10%' },
        { text: 'Actions', value: 'actions', align: 'start', width: '4%' },
      ],
      globalMappingHeaders: [
        { text: 'Structure', value: 'structure', align: 'start', width: '48%' },
        { text: 'Global Mapping ID', value: 'globalMappingId', align: 'start', width: '48%' },
        { text: 'Actions', value: 'actions', align: 'start', width: '4%' },
      ],
      // Data will be loaded from CTS API
      isLoading: false,
      integrationEntities: [],
      nextId: 1,
      globalMappings: [],
      nextGlobalMappingId: 1
    }
  },
  mounted() {
    this.loadIntegrationEntities()
    this.loadGlobalMappings()
  },
  methods: {
    getAuthHeaders(extra = {}) {
      const token = (typeof sessionStorage !== 'undefined') ? sessionStorage.getItem('jwt_token') : null
      const authPart = token ? { Authorization: 'Bearer ' + token } : {}
      return { ...authPart, ...extra }
    },
    showAlert(message, type = 'success') {
      if (typeof window !== 'undefined' && typeof window.showAlert === 'function') {
        window.showAlert(message, type)
      } else {
        console.log(`[MOISettings][${type}]`, message)
      }
    },
    addRow() {
      this.integrationEntities.push({
        id: null,
        tempId: this.nextId++,
        structure: null,
        url: '',
        username: '',
        password: '',
        active: true
      })
      console.log('[MOISettings] addRow -> new temp row', this.integrationEntities[this.integrationEntities.length - 1])
    },
    async removeRow(index) {
      const row = this.integrationEntities[index]
      const ctsStructureId = row && row.structure ? row.structure.id : null
      try {
        if (ctsStructureId) {
          await axios.delete(constants.baseApiUrl + 'MOISettings/IntegrationEntities/' + ctsStructureId, {
            headers: this.getAuthHeaders()
          })
          // this.showSnackbar('Integration entity deleted successfully', 'success')
        }
        // Remove locally regardless (covers unsaved rows without structure yet)
        this.integrationEntities.splice(index, 1)
        this.showAlert('Integration entity deleted successfully', 'success')
      } catch (error) {
        console.error('Error deleting integration entity:', error)
        this.showAlert('Failed to delete integration entity', 'error')
      }
    },
    async loadIntegrationEntities() {
      this.isLoading = true
      try {
        const res = await axios.get(constants.baseApiUrl + 'MOISettings/IntegrationEntities', {
          headers: this.getAuthHeaders()
        })
        const list = Array.isArray(res.data) ? res.data : []
        this.integrationEntities = list.map(item => ({
          id: item.id,
          structure: item.ctsStructureId ? { id: item.ctsStructureId, name: item.structureName, isUser: false } : null,
          url: item.url || '',
          username: item.username || '',
          password: '',
          active: item.active != null ? item.active : true
        }))
        const maxId = this.integrationEntities.length ? Math.max(...this.integrationEntities.map(e => e.id || 0)) : 0
        this.nextId = maxId + 1
      } catch (error) {
        console.error('Error loading integration entities:', error)
        this.showAlert('Failed to load integration entities', 'error')
      } finally {
        this.isLoading = false
      }
    },
    async saveRow(row) {
      try {
        const hasValidId = row && row.id !== null && row.id !== undefined && row.id !== '' && row.id > 0
        const payload = {
          id: hasValidId ? row.id : 0,
          entityName: (row.structure && row.structure.name) ? row.structure.name : (row.entityName || 'custom_entity'),
          externalSiteId: row.externalSiteId != null ? row.externalSiteId : 0,
          url: row.url || '',
          ctsStructureId: row.structure && row.structure.id ? row.structure.id : null,
          active: row.active != null ? row.active : true,
          username: row.username || '',
          password: row.password || ''
        }
        const method = hasValidId ? 'put' : 'post'
        console.log('[MOISettings] saveRow -> method:', method, 'row.id:', row.id, 'payload:', payload)
        const res = await axios({
          method,
          url: constants.baseApiUrl + 'MOISettings/IntegrationEntities',
          data: payload,
          headers: this.getAuthHeaders({ 'Content-Type': 'application/json-patch+json' })
        })
        console.log('[MOISettings] saveRow response:', res && res.data)
        if (res && res.data) {
          row.id = res.data.id
          if (row.tempId) delete row.tempId
          if (res.data.structureName) {
            if (!row.structure && res.data.ctsStructureId) {
              row.structure = { id: res.data.ctsStructureId, name: res.data.structureName, isUser: false }
            } else if (row.structure) {
              row.structure.name = res.data.structureName
            }
          }
        }
        this.showAlert(method === 'post' ? 'Integration entity created successfully' : 'Integration entity updated successfully', 'success')
      } catch (error) {
        console.error('[MOISettings] Error saving row:', error)
        this.showAlert('Failed to save integration entity', 'error')
      }
    },
    backToAdminPage() {
      router.push({ name: 'admin' })
    },
    async loadGlobalMappings() {
      this.isLoading = true
      try {
        const res = await axios.get(constants.baseApiUrl + 'MOISettings/ESBGlobalMappings', {
          headers: this.getAuthHeaders()
        })
        const list = Array.isArray(res.data) ? res.data : []
        this.globalMappings = list.map(item => ({
          id: item.id,
          structure: item.structureId ? { id: item.structureId, name: item.structureName, isUser: false } : null,
          globalMappingId: item.globalUnitId || ''
        }))
        const maxId = this.globalMappings.length ? Math.max(...this.globalMappings.map(e => e.id || 0)) : 0
        this.nextGlobalMappingId = maxId + 1
      } catch (error) {
        console.error('Error loading global mappings:', error)
        this.showAlert('Failed to load global mappings', 'error')
      } finally {
        this.isLoading = false
      }
    },
    addGlobalMapping() {
      this.globalMappings.push({
        id: null,
        tempId: this.nextGlobalMappingId++,
        structure: null,
        globalMappingId: ''
      })
      console.log('[MOISettings] addGlobalMapping -> new temp row', this.globalMappings[this.globalMappings.length - 1])
    },
    async removeGlobalMapping(index) {
      const row = this.globalMappings[index]
      const mappingId = row && row.id
      try {
        if (mappingId) {
          await axios.delete(constants.baseApiUrl + 'MOISettings/ESBGlobalMappings/' + mappingId, {
            headers: this.getAuthHeaders()
          })
          this.showAlert('Global mapping deleted successfully', 'success')
        }
        this.globalMappings.splice(index, 1)
      } catch (error) {
        console.error('Error deleting global mapping:', error)
        this.showAlert('Failed to delete global mapping', 'error')
      }
    },
    async saveGlobalMapping(row) {
      try {
        const hasValidId = row && row.id !== null && row.id !== undefined && row.id !== '' && row.id > 0
        const method = hasValidId ? 'put' : 'post'
        const payload = {
          structureId: row.structure && row.structure.id ? row.structure.id : null,
          globalUnitId: row.globalMappingId || ''
        }
        if (hasValidId) {
          payload.id = row.id
        }
        console.log('[MOISettings] saveGlobalMapping -> method:', method, 'row.id:', row.id, 'payload:', payload)
        const res = await axios({
          method,
          url: constants.baseApiUrl + 'MOISettings/ESBGlobalMappings',
          data: payload,
          headers: this.getAuthHeaders({ 'Content-Type': 'application/json-patch+json' })
        })
        console.log('[MOISettings] saveGlobalMapping response:', res && res.data)
        if (res && res.data) {
          row.id = res.data.id
          if (row.tempId) delete row.tempId
          if (res.data.structureName) {
            if (!row.structure && res.data.structureId) {
              row.structure = { id: res.data.structureId, name: res.data.structureName, isUser: false }
            } else if (row.structure) {
              row.structure.name = res.data.structureName
            }
          }
        }
        this.showAlert(method === 'post' ? 'Global mapping created successfully' : 'Global mapping updated successfully', 'success')
      } catch (error) {
        console.error('[MOISettings] Error saving global mapping:', error)
        this.showAlert('Failed to save global mapping', 'error')
      }
    }
  }
}
</script>

<style scoped>
table, th, td {
  border: 1px solid #ccc;
}

:deep(.v-data-table__header th) {
  background-color: #f5f5f5 !important;
  font-size: 38px !important;
  font-weight: 600 !important;
  padding: 16px !important;
  color: #333 !important;
  text-align: center !important;
}

.pa-2 {
  padding: 8px;
}

:deep(.custom-tooltip .v-tooltip__content) {
  font-size: 16px !important;
  padding: 40px 60px !important;
  min-height: 80px !important;
  min-width: 120px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.tooltip-text {
  font-size: 16px;
  padding: 4px 0;
}

:deep(.v-menu__content) {
  z-index: 99999 !important;
}

:deep(.v-autocomplete__content) {
  z-index: 99999 !important;
}

:deep(.v-select__content) {
  z-index: 99999 !important;
}

:deep(.v-data-table) {
  overflow: visible !important;
}

:deep(.v-data-table__wrapper) {
  overflow: visible !important;
}

:deep(tbody tr) {
  overflow: visible !important;
}

:deep(tbody tr td) {
  overflow: visible !important;
  position: relative;
}

:deep(.v-card) {
  overflow: visible !important;
}

.report-container {
  overflow: visible !important;
}
</style>
